"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var dialog_1 = require("../../../../components/pricing/layout/dialog/dialog");

var static_text_1 = require("../../../../components/pricing/text/static-text/static-text");

var drug_search_help_dialog_content_1 = require("../../../../theming/pricing-system/drug-search-help-dialog.content");

var DrugSearchHelpDialog = function (_super) {
  __extends(DrugSearchHelpDialog, _super);

  function DrugSearchHelpDialog() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DrugSearchHelpDialog.prototype.render = function () {
    var buttons = [{
      onPress: this.props.onClose,
      text: drug_search_help_dialog_content_1.DrugSearchHelpDialogContent.closeButtonText,
      type: 'close'
    }];
    var viewStyle = {
      marginBottom: '0.5rem',
      marginTop: '0.5rem'
    };
    var criteriaStaticTextStyle = {
      fontSize: '1rem'
    };
    var criteriaExampleStaticTextStyle = {
      fontSize: '1.1rem',
      fontWeight: 'bold'
    };
    return react_1.default.createElement(dialog_1.Dialog, {
      title: drug_search_help_dialog_content_1.DrugSearchHelpDialogContent.title,
      viewStyle: this.props.viewStyle,
      buttons: buttons
    }, react_1.default.createElement(react_native_1.View, {
      style: viewStyle
    }, react_1.default.createElement(static_text_1.StaticText, {
      text: drug_search_help_dialog_content_1.DrugSearchHelpDialogContent.searchByNdcLabel,
      textStyle: criteriaStaticTextStyle
    }), react_1.default.createElement(static_text_1.StaticText, {
      text: drug_search_help_dialog_content_1.DrugSearchHelpDialogContent.searchByNdcExample,
      textStyle: criteriaExampleStaticTextStyle
    })), react_1.default.createElement(react_native_1.View, {
      style: viewStyle
    }, react_1.default.createElement(static_text_1.StaticText, {
      text: drug_search_help_dialog_content_1.DrugSearchHelpDialogContent.searchByNameLabel,
      textStyle: criteriaStaticTextStyle
    }), react_1.default.createElement(static_text_1.StaticText, {
      text: drug_search_help_dialog_content_1.DrugSearchHelpDialogContent.searchByNameExample,
      textStyle: criteriaExampleStaticTextStyle
    })), react_1.default.createElement(react_native_1.View, {
      style: viewStyle
    }, react_1.default.createElement(static_text_1.StaticText, {
      text: drug_search_help_dialog_content_1.DrugSearchHelpDialogContent.searchWithUnitsLabel,
      textStyle: criteriaStaticTextStyle
    }), react_1.default.createElement(static_text_1.StaticText, {
      text: drug_search_help_dialog_content_1.DrugSearchHelpDialogContent.searchWithUnitsExample,
      textStyle: criteriaExampleStaticTextStyle
    })), react_1.default.createElement(react_native_1.View, {
      style: viewStyle
    }, react_1.default.createElement(static_text_1.StaticText, {
      text: drug_search_help_dialog_content_1.DrugSearchHelpDialogContent.searchByPartialNameLabel,
      textStyle: criteriaStaticTextStyle
    }), react_1.default.createElement(static_text_1.StaticText, {
      text: drug_search_help_dialog_content_1.DrugSearchHelpDialogContent.searchByPartialNameExample,
      textStyle: criteriaExampleStaticTextStyle
    })), react_1.default.createElement(react_native_1.View, {
      style: viewStyle
    }, react_1.default.createElement(static_text_1.StaticText, {
      text: drug_search_help_dialog_content_1.DrugSearchHelpDialogContent.searchWithBrandLabel,
      textStyle: criteriaStaticTextStyle
    }), react_1.default.createElement(static_text_1.StaticText, {
      text: drug_search_help_dialog_content_1.DrugSearchHelpDialogContent.searchWithBrandExample,
      textStyle: criteriaExampleStaticTextStyle
    })));
  };

  return DrugSearchHelpDialog;
}(react_1.default.Component);

exports.DrugSearchHelpDialog = DrugSearchHelpDialog;